import { get, set } from 'lodash';
import {
    call,
    fork,
    put,
    take,
    select
} from 'redux-saga/effects';

import {
    SAVE_INITIAL_VALUES,
    appInitialized
} from '../actions/initialActions.js';

import { USER_AGREED_TO_COOKIES } from '../actions/cookiesAlertActions.js';

import { requestCartItemsSaga } from './cartSagas';

import { getCustomerInfoSaga } from './userSagas';

import { cookieSaga } from './cookieSagas';
import { backToCatalogSaga } from './backToCatalogSagas';
import { randomizeFooterPromoSaga } from './promoSagas';

import { attachUserAgentString } from '../utils/cssUtils';
import { attachProductTileHover } from '../utils/eventUtils';
import { usingPwaHeader } from '../utils/headerUtils';
import { debug } from '../utils/logger';
import { updateDeviceSizeSaga } from './deviceSagas';

import { incrementUniquePageVisitsCount } from '../utils/cookieUtils';
import { fetchFavorites } from '../actions/favoritesActions';

// Export data to be shared with PWA orchestrated header
function exportSharedData(state) {
    set(window, 'urbn.sharedData.pageType', get(state, 'core.pageType'));
}

export function* initialSaga() {
    debug('Saga: initialSaga initialized');

    attachUserAgentString();

    yield take(SAVE_INITIAL_VALUES);

    if (!usingPwaHeader()) {
        yield fork(cookieSaga);
        yield take(USER_AGREED_TO_COOKIES);
    }

    yield fork(backToCatalogSaga);

    // increment page visits count cookie
    incrementUniquePageVisitsCount();

    yield call(getCustomerInfoSaga);
    yield call(randomizeFooterPromoSaga);
    yield fork(requestCartItemsSaga);
    yield fork(updateDeviceSizeSaga);
    yield put(fetchFavorites());

    const state = yield select();

    attachProductTileHover(state);
    exportSharedData(state);

    // global version var added for DY to know which app to target
    // PWA version (3.*) or Monoweb version (2.*)
    set(window, 'urbn.version', get(state, 'core.buildVersion'));

    yield put(appInitialized());
    document.dispatchEvent(new CustomEvent('a15-app-ready'));
}

export function* coreInitialSaga() {
    yield call(initialSaga);
}

export default [
    initialSaga
];
